import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HousekeepingComponent } from './components/housekeeping.component';
import { LoginComponent } from './components/login.component';
import { LogoutComponent } from './components/logout.component';
import { ProfileComponent } from './components/profile.component';
import { ResetPasswordComponent } from './components/reset-password.component';
import { PreferencesComponent } from './components/preferences.component';

const routes: Routes = [
   { path: '', redirectTo: 'login', pathMatch: 'full' },
   { path: 'login', component: LoginComponent },
   { path: 'logout', component: LogoutComponent },
   { path: 'resetPassword', component: ResetPasswordComponent },
   { path: 'preferences', component: PreferencesComponent },
  { path: 'profile', component: ProfileComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class HousekeepingRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/housekeeping-routing.module.ts